export default function PHP_MySQLCreateDB() {
  return (
    <div>
      <h1>PHP_MySQLCreateDB</h1>
    </div>
  );
}
